/**
 * Aktualisiert das Produktraster einer Kollektionsseite automatisch im Hintergrund,
 * ohne dass Besucher die Seite neu laden müssen (z. B. wenn neue Produkte live gehen).
 * Nutzt Shopifys Section Rendering API (?section_id=...) und tauscht nur das
 * #ProductGridContainer-Element aus, wenn sich die enthaltenen Produkt-Links geändert haben.
 */
(function () {
  const POLL_MS = 25000;

  function getContainer() {
    return document.getElementById('ProductGridContainer');
  }

  function signature(root) {
    return Array.from(root.querySelectorAll('#product-grid a[href*="/products/"]'))
      .map((a) => a.getAttribute('href'))
      .filter((href, i, arr) => href && arr.indexOf(href) === i)
      .sort()
      .join('|');
  }

  function showToast() {
    const toast = document.createElement('div');
    toast.textContent = 'Neue Produkte sind jetzt verfügbar';
    toast.setAttribute('role', 'status');
    Object.assign(toast.style, {
      position: 'fixed',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      background: '#111',
      color: '#fff',
      padding: '10px 18px',
      borderRadius: '999px',
      fontSize: '14px',
      zIndex: 9999,
      opacity: '0',
      transition: 'opacity 300ms ease',
      pointerEvents: 'none',
    });
    document.body.appendChild(toast);
    requestAnimationFrame(() => {
      toast.style.opacity = '1';
    });
    setTimeout(() => {
      toast.style.opacity = '0';
      setTimeout(() => toast.remove(), 300);
    }, 3500);
  }

  let inFlight = false;

  async function checkForUpdates() {
    if (inFlight || document.visibilityState !== 'visible') return;
    const container = getContainer();
    if (!container || !container.dataset.id) return;

    inFlight = true;
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', container.dataset.id);
      const res = await fetch(url.toString(), { credentials: 'same-origin' });
      if (!res.ok) return;

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const freshContainer = doc.getElementById('ProductGridContainer');
      if (!freshContainer) return;

      if (signature(freshContainer) === signature(container)) return;

      container.style.transition = 'opacity 200ms ease';
      container.style.opacity = '0';
      setTimeout(() => {
        freshContainer.style.opacity = '0';
        container.replaceWith(freshContainer);
        requestAnimationFrame(() => {
          freshContainer.style.transition = 'opacity 200ms ease';
          freshContainer.style.opacity = '1';
        });
        showToast();
      }, 200);
    } catch (err) {
      // Stiller Fehlschlag – Polling läuft beim nächsten Intervall einfach weiter.
    } finally {
      inFlight = false;
    }
  }

  if (getContainer()) {
    setInterval(checkForUpdates, POLL_MS);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') checkForUpdates();
    });
  }
})();
